<script context="module" lang="ts">
    import type { ArchivedPostFragment, ArchiveQuery } from '$gen/graphql';
    import type { Load } from '@sveltejs/kit';

    const limit = 50;

    export const load: Load = async ({ stuff, url }) => {
        const page = parseInt(url.searchParams.get('page')) || 0;
        const offset = page * limit;

        const query = await stuff.cms.archive({ limit, offset });

        return {
            props: {
                query,
                page,
            },
        };
    };
</script>

<script lang="ts">
    import { isArchivedPostTeaser } from '$lib/api/kubaparis/fragments';
    import ArchivedPostTeaser from '$lib/components/archive/ArchivedPostTeaser.svelte';
    import { routes } from '$lib/routes';

    export let query: ArchiveQuery;
    export let page: number;

    let postsByYear: Map<string, ArchivedPostFragment[]> = new Map();

    $: posts = query?.archivedPosts?.filter(isArchivedPostTeaser);
    $: if (posts) {
        postsByYear = new Map();
        posts.forEach((post) => {
            const year = post.year;
            if (postsByYear.has(year)) {
                postsByYear.set(year, [...postsByYear.get(year), post]);
            } else {
                postsByYear.set(year, [post]);
            }
        });
    }
</script>

<div>
    {#if postsByYear}
        {#each [...postsByYear.entries()] as [key, posts]}
            <div class="mb-1 mt-2 flex gap-40 font-serif text-xl">
                <span> Archive </span>
                <span>{key}</span>
            </div>
            <section
                class="grid auto-rows-auto grid-cols-4 gap-3 sm:grid-cols-6 md:grid-cols-10 lg:grid-cols-12"
            >
                {#each posts as post}
                    <ArchivedPostTeaser {post} />
                {/each}
            </section>
        {/each}
    {/if}
    <div class="flex justify-between">
        {#if page > 0}
            <a href={routes.archive_page(page - 1)}>Newer Posts</a>
        {:else}
            <div />
        {/if}
        <a href={routes.archive_page(page + 1)}>Older Posts</a>
    </div>
</div>
